// -*- js -*-

import R from 'ramda'
import FlydAdapter from './flyd_adapter'

const flyd = new FlydAdapter()
export default flyd



/** WEBPACK FOOTER **
 ** ./src/stream/index.js
 **/